var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect-field',_vm._b({attrs:{"options":_vm.languages},on:{"change":function($event){return _vm.$emit('change', $event)},"source-change":function($event){return _vm.$emit('source-change', $event)}}},'multiselect-field',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }